import { Button } from '@finn/design-system/atoms/button';
import { BASE_SUBSCRIPTION_PATH } from '@finn/ua-constants';
import { useVoucherStore, VoucherType } from '@finn/ua-vehicle';
import { useCurrentLocale, useIntl } from '@finn/ui-utils';
import { getLocalstorageValue, StorageKeys } from '@finn/ui-utils/ssr';
import dayjs from 'dayjs';
import { useCallback, useContext, useEffect, useState } from 'react';

import CheckoutContext from '~/contexts/Checkout.tsx';
import { removeVoucher } from '~/services/voucher.ts';

export const DelayBookingBanner = () => {
  const data = useVoucherStore((state) => state.referralVoucherData);
  const [isCheckout, setIsCheckout] = useState(false);
  const clearReferralVoucher = useVoucherStore(
    (state) => state.clearReferralVoucher
  );
  const isAbsoluteVoucher = data?.type === VoucherType.ABSOLUTE;
  const intl = useIntl();
  const [minMaxDates, setMinMaxDates] = useState({
    minDate: '',
    maxDate: '',
  });

  const { contactInfo } = useContext(CheckoutContext);
  const dealId = contactInfo?.dealId ?? '';
  const { locale } = useCurrentLocale();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const delay = getLocalstorageValue(StorageKeys.DELAY_MANAGEMENT);
    const isCheckoutPath = window.location.pathname.includes('/checkout');
    if (isCheckoutPath && !isCheckout) {
      setIsCheckout(true);
    }
    setMinMaxDates({
      minDate: urlParams.get('available_from') || delay?.available_from || '',
      maxDate: urlParams.get('available_to') || delay?.available_to || '',
    });
  }, [isCheckout]);

  const delayDescription = intl.formatMessage(
    isCheckout
      ? 'general.delayBanner.checkout'
      : isAbsoluteVoucher
        ? 'general.delayBanner.delayAbsolute'
        : 'general.delayBanner.delayRelative',
    {
      value: isAbsoluteVoucher
        ? intl.formatNumber(data?.value_abs ?? 0, {
            currency: 'EUR',
            style: 'currency',
            maximumFractionDigits: 0,
          })
        : (data?.value_rel ?? 0),
      min_date: minMaxDates.minDate
        ? dayjs(minMaxDates.minDate).locale(locale).format('DD MMM YYYY')
        : '--',
      max_date: minMaxDates.maxDate
        ? dayjs(minMaxDates.maxDate).locale(locale).format('DD MMM YYYY')
        : '--',
    }
  );

  const voucherCode = data?.code ?? '';

  const removeVoucherHandler = useCallback(async () => {
    localStorage.removeItem(StorageKeys.DELAY_MANAGEMENT);
    clearReferralVoucher();
    if (dealId) {
      await removeVoucher(voucherCode, dealId, locale);
      window.location.reload(); // some components might need a reload to reflect the changes
    } else {
      window.location.href = `/${locale}/${BASE_SUBSCRIPTION_PATH}`;
    }
  }, [clearReferralVoucher, dealId, locale, voucherCode]);

  return (
    <div className="mb-2 flex w-full flex-col gap-2 md:mb-0 md:flex-row md:items-center md:gap-4">
      <p className="pb-1 pt-4 body-14-light md:pb-4 md:body-16-light">
        {delayDescription}
      </p>
      <div className="inline-flex md:ml-auto">
        <Button size="sm" variant="action" onClick={removeVoucherHandler}>
          {intl.formatMessage('general.delayBanner.endAlternativeSearch')}
        </Button>
      </div>
    </div>
  );
};
